import * as t from "io-ts";

export const WarningValidator = t.intersection([
  t.type({
    type: t.string,
    message: t.string,
    priority: t.string,
  }),
  t.partial({}),
]);

export const WarningArrayValidator = t.array(WarningValidator);

export type Warning = t.TypeOf<typeof WarningValidator>;
export type WarningArray = t.TypeOf<typeof WarningArrayValidator>;
